import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import FamilyUpdateChild from "./FamilyUpdateChild";
import { useLocation } from "react-router-dom";

const FamilyUpdate = () => {
  const { state } = useLocation();
  const familyDetails = state;
  return (
    <MainTemplate>
      <CardBackground>
        <FamilyUpdateChild familyDetails={familyDetails} />
      </CardBackground>
    </MainTemplate>
  );
};

export default FamilyUpdate;
